import { trackPromise } from "react-promise-tracker";
import useProviders from "../../providers";

const useSettingsServices = () => {
  const { useSettingsProvider } = useProviders();
  const {
    listSettingsProvider,
    getSettingProvider,
    createSettingProvider,
    updateSettingProvider,
    deleteSettingProvider
  } = useSettingsProvider();

  const listSettingsService = ({ page, page_size, search }) => {
    return new Promise(async (resolve, reject) => {
      try {
        resolve(await trackPromise(listSettingsProvider({ page, page_size, search })));
      } catch (error) {
        reject(error);
      }
    });
  };

  const getSettingService = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        resolve(await trackPromise(getSettingProvider(id)));
      } catch (error) {
        reject(error);
      }
    });
  };

  const createSettingService = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        resolve(await trackPromise(createSettingProvider(data)));
      } catch (error) {
        reject(error);
      }
    });
  };

  const updateSettingService = (id, data) => {
    return new Promise(async (resolve, reject) => {
      try {
        resolve(await trackPromise(updateSettingProvider(id, data)));
      } catch (error) {
        reject(error);
      }
    });
  };

  const deleteSettingService = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        resolve(await trackPromise(deleteSettingProvider(id)));
      } catch (error) {
        reject(error);
      }
    });
  };

  return {
    listSettingsService,
    getSettingService,
    createSettingService,
    updateSettingService,
    deleteSettingService,
  };
};

export default useSettingsServices;
